// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RAL313gdlMdP9L88K0k5{display:flex;justify-content:space-between;align-items:center}.j15LWr1PbjXUP4TeqXtX{border:1px solid #c7c6c6;border-radius:3px;padding:6px 16px}.j15LWr1PbjXUP4TeqXtX:disabled{background-color:#e5e5e5}.gens0T6IzcTw8dpONv1v{display:flex;align-items:center;column-gap:5px;border:1px solid #c7c6c6;border-radius:3px;padding:6px 18px}.gens0T6IzcTw8dpONv1v svg{width:18px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"calendarTab": "RAL313gdlMdP9L88K0k5",
	"calendarTabArrow": "j15LWr1PbjXUP4TeqXtX",
	"calendarTabSelector": "gens0T6IzcTw8dpONv1v"
};
export default ___CSS_LOADER_EXPORT___;
